
export default defineNuxtPlugin((nuxtApp) => {
  const maintenanceMode = useRuntimeConfig().public.isMaintenanceMode
  console.log('maintenanceMode=====>>', maintenanceMode, window.location.pathname)
  if (maintenanceMode === 'true' && !window.location.pathname.includes('/maintenance')) {
    window.location.href = `/maintenance`
  }
});